'use client';

import { useTranslations } from 'next-intl';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { usePermissions } from '@/hooks/use-permissions';
import { WorkloadManagementTab } from './workload-management-tab';
import { ContainerAssignmentTab } from './container-assignment-tab';
import { SelfAssignTab } from './self-assign-tab';
import { ConnectivityStatusFooter } from './connectivity-status-footer';

export function HandoverScanningPage() {
  const t = useTranslations('handoverScanning');
  const { hasPermission } = usePermissions();
  const canSelfAssign = hasPermission('handover_scanning.self_assign');

  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-2xl font-bold tracking-tight'>{t('pageTitle')}</h1>
        <p className='text-muted-foreground'>{t('pageSubtitle')}</p>
      </div>

      <Tabs defaultValue='workload'>
        <TabsList>
          <TabsTrigger value='workload'>{t('tabWorkload')}</TabsTrigger>
          <TabsTrigger value='assignment'>{t('tabAssignment')}</TabsTrigger>
          {canSelfAssign && (
            <TabsTrigger value='self-assign'>{t('tabSelfAssign')}</TabsTrigger>
          )}
        </TabsList>
        <TabsContent value='workload'>
          <WorkloadManagementTab />
        </TabsContent>
        <TabsContent value='assignment'>
          <ContainerAssignmentTab />
        </TabsContent>
        {canSelfAssign && (
          <TabsContent value='self-assign'>
            <SelfAssignTab />
          </TabsContent>
        )}
      </Tabs>

      <ConnectivityStatusFooter />
    </div>
  );
}
